import { RoutesMounter } from '@/types';
import { index, member, redirectTo } from '@/app/navigation/functions';

import { DendreoLogsIndex } from '@/modules/admin/dendreo/pages/DendreoLogsIndex';
import { DendreoSyncInvoice } from '@/modules/admin/dendreo/pages/DendreoSyncInvoice';
import { DendreoInvoicesIndex } from '@/modules/admin/dendreo/pages/DendreoInvoicesIndex';

export const mountDendreoRoutes: RoutesMounter<unknown> = ({
  path,
  tools: { queryClient, t },
}) => [
  member({
    path,
    handle: { crumb: () => 'Dendreo' },
    children: [
      index({ loader: redirectTo('invoices') }),
      member({
        path: 'invoices',
        handle: { crumb: () => 'Factures' },
        children: [index({ Component: DendreoInvoicesIndex })],
      }),
      member({
        path: 'logs',
        handle: { crumb: () => 'Logs' },
        children: [index({ Component: DendreoLogsIndex })],
      }),
      member({
        path: 'sync_invoice',
        handle: { crumb: () => 'Synchroniser une facture' },
        Component: DendreoSyncInvoice,
      }),
    ],
  }),
];
